'use client';
import React from 'react';
import {
  StatisticsBlockComponent,
  StatsBlock,
  toStatsBlockProps,
} from '@bufdir/statistics-pages-components';

type Props = {
  data: any;
};

const PageBlockPreview: React.FC<Props> = ({ data }) => {
  const fakeComponent: StatisticsBlockComponent = {
    __component: 'statistics.statistics-block',
    id: data['id'] ?? '',
    block: data,
  };
  const origin = new URL(process.env.NEXT_PUBLIC_STATS_STRAPI_URL as string)
    .origin;
  const statsBlockProps = toStatsBlockProps(fakeComponent, 0, origin);

  return <StatsBlock {...statsBlockProps} />;
};

export default PageBlockPreview;
